import type { Messages } from './en';

/** 第四階段內容（生活）：零用錢、存錢筒、需要與想要、廣告、作業單、成果展、聽力、速食店（繁體中文・台灣）。 */
export const zhTWLife: Pick<Messages, 'life'> = {
  life: {
    mapNames: {} as Record<string, string>,
    zones: {
      fastFood: '漢堡角落',
    },
    objects: {
      life_piggy: '存錢筒',
      life_fastfood: '漢堡角落',
      life_adscreen: '廣告螢幕',
    },
    npc: {} as Record<string, string>,
    items: {
      umbrella: { name: '雨傘', desc: '下雨時讓你不會淋濕。下雨天它是「需要」！' },
    } as Record<string, { name: string; desc: string }>,

    need: '需要',
    want: '想要',
    mom: '媽媽',
    coins: (n: number) => `${n}🪙`,

    allowance: {
      title: '💰 每週零用錢',
      text: '早安！這是你這星期的零用錢：**100 枚硬幣**。\n你要怎麼分配呢？一部分拿來花，一部分放進存錢筒，一部分存起來買禮物。',
      split: '來規劃吧',
      hint: '按 − 和 + 來移動硬幣。加起來必須是 100。',
      spend: '🛍️ 拿來花',
      piggy: '🐷 存錢筒',
      gift: '🎁 禮物基金',
      presets: { balanced: '⚖️ 平均分配', saver: '🐷 存錢派', spender: '🛍️ 花錢派' },
      left: (n: number) => (n === 0 ? '✅ 100 枚硬幣都安排好了！' : n > 0 ? `還有 ${n} 枚硬幣沒安排` : `多了 ${-n} 枚硬幣`),
      confirm: '這就是我的計畫',
      momSaver: '哇，你存了好多！每個星期天，我會在你存錢筒裡多加 10%。看著它慢慢變多吧！',
      momBalanced: '很平衡的計畫。花一點、存一點、分享一點。',
      momSpender: '要花的好多喔！這是你的選擇——不過要記得，花完就沒了，要等到下星期六才有。',
    },

    interest: {
      title: '🐷 星期天加碼',
      text: (add: number, total: number) =>
        `媽媽看了看你的存錢筒，加進了 **${add} 枚硬幣**——就是你存的錢的 10%。\n現在裡面有 **${total} 枚硬幣**！\n\n這就是銀行給的「利息」：存著不動的錢，會自己慢慢變多。`,
      empty: '媽媽檢查你的存錢筒：空空的。「每個星期天，我會在你存的錢上多加 10%。就算只存 10 枚也會變多喔！」',
    },

    piggy: {
      text: (piggy: number, coins: number) => `一隻有投幣孔的粉紅小豬。裡面有：**${piggy}🪙**。口袋裡有：**${coins}🪙**。`,
      in: (n: number) => `存入 ${n}🪙`,
      out: (n: number) => `拿出 ${n}🪙`,
      all: '全部存進去',
      done: (piggy: number) => `叮噹！存錢筒裡現在有 ${piggy}🪙。`,
      outWarn: '把錢拿出來沒關係——只要先問問自己：這是「需要」還是「想要」？',
      wallet: '👛 打開我的錢包',
    },

    nw: {
      title: '小問題',
      ask: (item: string) => `付錢之前：**${item}**是「需要」還是「想要」？`,
      right: (item: string, kind: string) => `答對了！${item}是**${kind}**。`,
      wrong: (item: string, kind: string) => `嗯……${item}通常是**${kind}**喔。`,
      needWhy: '「需要」讓你保持健康、安全，並準備好上學。',
      wantWhy: '「想要」是額外的好東西。買它們沒關係——只要先做好計畫。',
      buy: '買下來',
    },

    ad: {
      sources: { tv: '📺 電視廣告', mall: '🏬 百貨公司螢幕', phone: '📱 手機彈跳廣告' },
      flash: '限時優惠！',
      only: '只有今天！',
      was: (n: number) => `原價 ${n}🪙`,
      now: (n: number) => `現在 ${n}🪙`,
      timer: (s: number) => `優惠倒數 ${s}…`,
      buy: (n: number) => `馬上買（${n}🪙）`,
      wait: '⏳ 等到明天再說',
      boughtLesson: (was: number, now: number) =>
        `你買了！不過再看一次：「原價 ${was}」是編出來的，${now} 才是平常的價格。\n廣告會用**限時**、**只有今天**這種催促的字眼，讓你還沒想清楚就先買。`,
      waitLesson: '聰明！已經加進你的願望清單。一個好方法：想要的東西，先等一天再買。如果明天還是想要，到時候再買也不遲。',
      poor: '你的硬幣不夠——但廣告還是想讓你覺得非買不可！',
    },

    wish: {
      title: '📝 你的願望清單',
      cheaper: (item: string, was: number, now: number) => `還記得廣告裡的${item}嗎？今天只要 **${now}🪙**，不是 ${was}🪙。那個「限時」優惠根本沒有那麼限時嘛！`,
      forgot: (item: string) => `你醒來想起廣告裡的${item}……其實你並不需要它。你的硬幣保住了！`,
      lesson: '等一天，能幫你分辨真正的需要和一時的想要，避免衝動購物。',
      buy: (n: number) => `現在用 ${n}🪙 買下來`,
      skip: '不用了，我要留著硬幣',
      kept: '硬幣存下來了。未來的你會跟你說謝謝！',
    },

    wallet: {
      title: '👛 我的錢包',
      menu: '👛 錢包',
      pocket: '口袋',
      piggy: '存錢筒',
      gift: '禮物基金',
      budget: '這週的預算',
      spent: (s: number, b: number) => (b ? `已花 ${s} / ${b}🪙` : `已花 ${s}🪙（還沒有計畫——零用錢星期六才發）`),
      over: '超出預算了！「想要」的東西，試著等到下星期再買。',
      donut: '這週的需要與想要',
      none: '這週還沒有花錢。',
      allTime: (n: number, w: number) => `累計：需要 ${n}🪙 · 想要 ${w}🪙`,
      wishes: '願望清單',
      noWishes: '空的——沒有衝動購物在等你。',
      quiz: (n: number) => `需要或想要答對的題數：${n}`,
      tip: '💡 小撇步',
      tips: [
        '先付錢給自己：購物前，先把硬幣放進存錢筒。',
        '「想要」不是壞事——先計畫好，買的時候會更開心。',
        '「原價 40，現在 25！」——「原價」常常是編出來的。',
        '套餐只有在你每樣都想吃的時候才划算。',
        '每週存 10 枚硬幣，一年就有 520 枚。',
        '買之前先問：我需要它嗎？我有地方放嗎？下星期我還會想要嗎？',
        '比較「一個」的價格：3 個 45 是每個 15；2 個 28 是每個 14。',
      ],
    },

    ws: {
      kinds: { homework: '📒 作業單', quiz: '📝 小考', exam: '🧪 考試' },
      gradeLabel: (g: number) => `${g} 年級`,
      progress: (i: number, n: number) => `第 ${i} 題，共 ${n} 題`,
      types: { spell: '🔤 拼字', cloze: '✏️ 填空', math: '🪙 金錢數學', reading: '📖 閱讀', logic: '🧩 邏輯' },
      spellHint: '仔細聽，然後依照順序點字母。',
      clozeHint: '選出缺少的單字。',
      mathHint: '算算看——需要的話可以用計算紙！',
      readingHint: '先讀文章，再回答問題。',
      logicHint: '找出規律。',
      hear: '🔊 聽一聽',
      undo: '⌫ 刪除',
      next: '下一題 ▶',
      finish: '看我的成績',
      right: '✅ 答對了！',
      wrong: (a: string) => `❌ 答案是：${a}`,
      result: (s: number, n: number) => `答對 ${s} / ${n} 題`,
      comments: { A: '表現優異！🌟', B: '做得好——再多練習一點！', C: '繼續加油——錯誤能幫助你學習。' },
      done: '交出去',
      math: {
        items: ['飯糰', '果汁', '鉛筆', '貼紙', '筆記本', '鑰匙圈'],
        left: (a: number, item: string, b: number) => `你有 ${a} 枚硬幣。你用 ${b} 枚硬幣買了一個${item}。還剩下幾枚硬幣？`,
        change: (n: number, item: string, p: number, pay: number) => `你買了 ${n} 個${item}，每個 ${p} 枚硬幣，付了 ${pay} 枚硬幣。要找你多少錢？`,
        discount: (item: string, p: number, d: number) => `一個${item}要 ${p} 枚硬幣。今天特價，便宜 ${d}%。新的價格是多少？`,
        weeks: (x: number, item: string, y: number) => `你每週存 ${x} 枚硬幣。要幾週才能買得起 ${y} 枚硬幣的${item}？`,
        unit: (item: string, nA: number, pA: number, nB: number, pB: number) =>
          `A 包：${nA} 個${item}賣 ${pA} 枚硬幣。B 包：${nB} 個${item}賣 ${pB} 枚硬幣。比較便宜的那包，一個${item}多少錢？`,
        interest: (p: number) => `你的存錢筒裡有 ${p} 枚硬幣。媽媽每週加 10%（按新的總數計算）。2 週後有幾枚硬幣？`,
      },
      logic: (seq: string) => `下一個是什麼？  ${seq}, ?`,
    },

    desk: {
      portfolio: '🖼️ 我的作品集',
      worksheet: '你的作業單準備好了：五題適合你年級的題目。',
    },

    exhibit: {
      title: '🖼️ 學習成果展',
      titlePortfolio: '🖼️ 我的作品集',
      today: '今天是**成果展**！每四週學校會展出同學們的作品。你的作業單、畫作和印章都貼在牆上了。',
      see: '看看我的角落',
      works: '最棒的作業單',
      noWorks: '還沒有作業單——到書桌寫作業吧。',
      drawings: 'PixelBook 畫作',
      noDrawings: '還沒有畫作——用手機裡的 PixelBook 畫點東西吧。',
      stamps: '護照印章',
      noStamps: '還沒有印章——去旅行、一起過節吧！',
      reward: (n: number) => `參觀的人都很喜歡你的角落！+${n}⭐`,
      next: (w: number) => `下次成果展：第 ${w} 週`,
    },

    listen: {
      tab: '👂 聽力',
      pick: '👂 聽一聽選一選',
      dict: '⌨️ 聽寫',
      pickHint: '仔細聽，然後點你聽到的內容。',
      dictHint: '仔細聽，然後打出你聽到的內容。',
      play: '🔊 播放',
      slow: '🐢 慢速',
      check: '檢查',
      placeholder: '在這裡輸入…',
      ok: '完全正確！',
      close: (a: string) => `差一點！答案是：「${a}」`,
      bad: (a: string) => `不太對。答案是：「${a}」`,
      next: '下一題 ▶',
      streak: (n: number) => `🔥 連續答對：${n}`,
      shadow: '🎤 說說看',
    },

    replay: { again: '🔊', slow: '🐢', mic: '🎤', listening: '聆聽中…', good: '跟讀得很棒！', retry: (h: string) => `我聽到的是「${h}」。再試一次！` },

    grade: { title: '🎒 年級', hint: '設定作業和考試的難度。', names: ['三年級', '四年級', '五年級', '六年級'] },

    ff: {
      title: '🍔 漢堡角落',
      hint: '用英文點餐，順便比較價格！',
      menu: [
        { name: '起司漢堡', desc: '熱呼呼又有飽足感', en: 'a cheeseburger' },
        { name: '薯條', desc: '鹹鹹脆脆', en: 'some fries' },
        { name: '可樂', desc: '非常甜（糖很多！）', en: 'a cola' },
        { name: '套餐', desc: '漢堡 + 薯條 + 可樂', en: 'the combo meal' },
        { name: '🥗 蔬菜捲 + 豆漿', desc: '健康的選擇', en: 'a veggie wrap and a soy milk' },
      ],
      compare: '🧮 要不要點套餐？',
      compareText: (sum: number, combo: number) => `漢堡 + 薯條 + 可樂分開買 = **${sum}🪙**。套餐 = **${combo}🪙**。省了 ${sum - combo}🪙——但前提是三樣你都想要！`,
      water: '想要免費的水？只要問：“Can I have some water, please?”',
      cashier: '店員',
      greet: 'Hi! Welcome to Burger Corner. What can I get for you?', // English practice
      prompt: '選出有禮貌的點餐說法：',
      wrong: ['店員眨了眨眼。“Sorry? Could you say that politely?”', '嗯，聽起來有點沒禮貌。試試看 “Can I have…, please?”'],
      done: 'Here you go! Enjoy your meal!', // English practice
      poor: '硬幣不夠。要不要選便宜一點的？',
      healthy: '健康的選擇！你的身體謝謝你。+2⭐',
      tooMuch: '吃了好多鹽和糖……你覺得身體有點沉重。',
      look: '我只是看看，謝謝',
      waterDone: 'Sure! Here’s a cup of water.', // English practice
    },

    save: {
      menu: '🔑 存檔代碼',
      title: '🔑 存檔代碼',
      exportHint: '複製這組代碼，就能保存你的遊戲，或轉移到另一台裝置。',
      copy: '📋 複製代碼',
      copied: '已複製！',
      importHint: '在這裡貼上存檔代碼，就能載入那個遊戲。',
      placeholder: '貼上代碼…',
      load: '📥 載入這組代碼',
      bad: '這組代碼無法使用。請確認你有完整複製。',
      confirm: '要載入這個存檔嗎？目前的遊戲會被取代。',
      startButton: '🔑 載入存檔代碼',
    },

    journal: {
      allowance: (split: string) => `規劃了我的零用錢：${split}`,
      exhibit: '在成果展展出了我的作品',
      waited: '等了一天，沒有衝動購物',
      worksheet: (g: string) => `作業單得到 ${g}`,
    },
  },
};
